/* eslint-disable react/display-name */
import moment from 'moment'
import { FC, ReactElement, useMemo, useState } from 'react'
import Table from '../../components/table'
import { Statement } from '../../externals/api/subscriptions'
import { usePlans } from '../../hooks/plans'
import { toReais } from '../../utils/formatter'
import { ContainerStatement, CreditCard } from './style'

const StatementContainer: FC = (): ReactElement | null => {
  const [isLoading, setIsLoading] = useState(false)
  const { getStatement, statements } = usePlans()

  useMemo(() => {
    setIsLoading(true)
    getStatement().finally(() => setIsLoading(false))
  }, [setIsLoading, getStatement])

  const columns = useMemo(() => {
    return [
      {
        title: 'Cartão',
        dataIndex: 'lastFourDigits',
        render: (lastFourDigits: string, { brand }: Statement) => (
          <CreditCard>
            <span>**** {lastFourDigits}</span>
            {String(brand).toLowerCase() === 'mastercard' && <i className='pf pf-mastercard' />}
            {String(brand).toLowerCase() === 'visa' && <i className='pf pf-visa' />}
          </CreditCard>
        )
      },
      {
        title: 'Valor',
        dataIndex: 'amount',
        render: (amount: number) => toReais(amount)
      },
      {
        title: 'Data do último pagamento',
        dataIndex: 'createdAt',
        render: (createdAt: string) => moment(createdAt).format('DD/MM/YYYY')
      }
    ]
  }, [])

  return (
    <ContainerStatement>
      <Table
        loading={isLoading && statements.length === 0}
        columns={columns}
        data={statements}
      />
    </ContainerStatement>
  )
}

export default StatementContainer
